import { protectedReq } from '../../helpers/requestHelper';

const parseResponse = async response => {
    try {
        return await response.json();
    } catch (err) {
        return { status: false, msg: 'invalid-response' };
    }
};

export const odooOverview = async () => {
    try {
        return parseResponse(await protectedReq('odoo/overview'));
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};

export const odooCatalog = async () => {
    try {
        return parseResponse(await protectedReq('odoo/catalog'));
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};

export const updateOdooVariantSettings = async (variantId, settings) => {
    try {
        return parseResponse(await protectedReq(
            `odoo/variant/${variantId}/settings`,
            settings,
            'PUT'
        ));
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};

// Compatibilidad temporal con consumidores anteriores.
export const odooProductList = async () => {
    try {
        return parseResponse(await protectedReq('odoo/list'));
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};
